import { isMobile } from 'mobile-device-detect'

export default function() {
    return {
        isMobile,
        ticketValid: false,
        validMessage: 'Cartão válido.',
        invalidMessage: 'Esse cartão de embarque não é mais válido.',
        ticketMessage: null,
        order: {
            trip: {}
        },
        apiUrl: process.env.VUE_APP_API_URL,
        baseUrl: process.env.VUE_APP_BASE_URL,
        urlQrCode: null,
        cadasturImagePath: '/assets/img/cadastur.webp',
        vaidator: false
    }
}
